<template>
  <div>
    <!-- 微餐饮 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>活动管理</el-breadcrumb-item>
      <el-breadcrumb-item>活动列表</el-breadcrumb-item>
      <el-breadcrumb-item>活动详情</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="tab">
      <span
        v-for="(v,i) in tabBtn"
        :key="v.id"
        @click="tabTitle(i)"
        :class="activeIndex==i?'activeTab':''"
      >{{v.name}}</span>
    </div>

    <!-- 餐厅管理 -->
    <div v-if="activeIndex==0">
      <el-card>
        <div class="titleSear">
          <div>
            <el-button @click="addRestaurantFn()">添加餐厅</el-button>
          </div>
          <div>
            <div>
              <el-button>排序</el-button>
            </div>
            <div>
              <el-button>删除</el-button>
            </div>
          </div>
        </div>
        <div class="tableOne">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            :header-cell-style="tableHeaderColorLeft"
            :cell-style="cellStyleLeft"
            key="one"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column label="排序" sortable width="120">
              <template>
                <el-input></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="餐厅名称" width="800"></el-table-column>
            <el-table-column prop="address" label="店铺状态">
              <template slot-scope="scope">
                <el-switch v-model="value3" active-color="#246DEB" inactive-color="#E5E5EA"></el-switch>
              </template>
            </el-table-column>
            <el-table-column prop="address" label="下单模式">
              <template slot-scope="scope">
                <img src="@/images/scenic/hj.png" alt />
                <img src="@/images/scenic/cz.png" alt />
                <span style="margin-left:10px">{{scope.row.address}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="address" label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="gateAuthorFn(scope.row)">档口授权</el-button>
                <el-button type="text" @click="addRestaurantFn(scope.row)">编辑</el-button>
                <el-button type="text" style="color: #E74C3C;">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页开始 -->
        <div class="pagination">
          <span class="demonstration">共几条记录，</span>
          <span class="demonstration">当前显示第几页</span>
          <el-pagination background layout="prev, pager, next" :total="1000"></el-pagination>
        </div>
        <!-- 分页结束 -->
      </el-card>
    </div>
    <!-- 档口管理 -->
    <div v-if="activeIndex==1">
      <el-card>
        <div class="titleSear">
          <div>
            <el-button @click="foodAddFn()">添加档口</el-button>
          </div>
          <div>
            <div>
              <el-button>排序</el-button>
            </div>
            <div>
              <el-button>删除</el-button>
            </div>
          </div>
        </div>
        <div class="tableOne">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            :header-cell-style="tableHeaderColorLeft"
            :cell-style="cellStyleLeft"
            key="two"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column label="排序" sortable width="120">
              <template>
                <el-input></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="档口名称" width="1200"></el-table-column>
            <el-table-column prop="address" label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="foodAuthorFn(scope.row)">菜品授权</el-button>
                <el-button type="text" @click="foodAddFn(scope.row)">编辑</el-button>
                <el-button type="text" style="color: #E74C3C;">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页开始 -->
        <div class="pagination">
          <span class="demonstration">共几条记录，</span>
          <span class="demonstration">当前显示第几页</span>
          <el-pagination background layout="prev, pager, next" :total="1000"></el-pagination>
        </div>
        <!-- 分页结束 -->
      </el-card>
    </div>
    <!-- 档口管理结束 -->
    <!-- 分类管理开始 -->
    <div v-if="activeIndex==2">
      <el-card>
        <div class="titleSear">
          <div>
            <el-button @click="classAddFn()">添加类别</el-button>
          </div>
          <div>
            <div>
              <el-button>排序</el-button>
            </div>
            <div>
              <el-button>删除</el-button>
            </div>
          </div>
        </div>
        <div class="tableOne">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            :header-cell-style="tableHeaderColorLeft"
            :cell-style="cellStyleLeft"
            key="three"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column label="排序" sortable width="120">
              <template>
                <el-input></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="类别名称" width="1100"></el-table-column>
            <el-table-column prop="name" label="分类状态">
              <template slot-scope="scope">
                <el-switch v-model="value3" active-color="#246DEB" inactive-color="#E5E5EA"></el-switch>
              </template>
            </el-table-column>
            <el-table-column prop="address" label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="classAddFn(scope.row)">编辑</el-button>
                <el-button type="text" style="color: #E74C3C;">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页开始 -->
        <div class="pagination">
          <span class="demonstration">共几条记录，</span>
          <span class="demonstration">当前显示第几页</span>
          <el-pagination background layout="prev, pager, next" :total="1000"></el-pagination>
        </div>
        <!-- 分页结束 -->
      </el-card>
    </div>
    <!-- 分类管理结束 -->
    <!-- 菜品管理开始 -->
    <div v-if="activeIndex==3">
      <el-card>
        <div class="vegetableBox">
          <div>
            <el-select v-model="value" placeholder="全部分类">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-button class="btn1">查询</el-button>
          </div>
          <div>
            <div>
              <el-button class="btn2" @click="vegetableAddFn()">添加菜品</el-button>
            </div>
            <div>
              <el-button class="btn3">排序</el-button>
            </div>
            <div>
              <el-button class="btn4">删除</el-button>
            </div>
          </div>
        </div>
        <div class="tableOne">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            :header-cell-style="tableHeaderColorLeft"
            :cell-style="cellStyleLeft"
            key="four"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column label="排序" sortable width="120">
              <template>
                <el-input></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="菜名"></el-table-column>
            <el-table-column prop="name" label="商品单价"></el-table-column>
            <el-table-column prop="name" label="商品分类"></el-table-column>
            <el-table-column prop="name" label="日库存"></el-table-column>
            <el-table-column prop="name" label="每单限购"></el-table-column>
            <el-table-column prop="name" label="限购日期"></el-table-column>
            <el-table-column prop="name" label="限购时间"></el-table-column>
            <el-table-column prop="name" label="档口名称"></el-table-column>
            <el-table-column prop="name" label="使用状态">
              <template slot-scope="scope">
                <el-switch v-model="value3" active-color="#246DEB" inactive-color="#E5E5EA"></el-switch>
              </template>
            </el-table-column>
            <el-table-column prop="address" label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="vegetableAddFn(scope.row)">编辑</el-button>
                <el-button type="text" style="color: #E74C3C;">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页开始 -->
        <div class="pagination">
          <span class="demonstration">共几条记录，</span>
          <span class="demonstration">当前显示第几页</span>
          <el-pagination background layout="prev, pager, next" :total="1000"></el-pagination>
        </div>
        <!-- 分页结束 -->
      </el-card>
    </div>
    <!-- 菜品管理结束 -->
    <!-- 桌位管理开始 -->
    <div v-if="activeIndex==4">
      <el-card>
        <div class="vegetableBox">
          <div>
            <el-select v-model="value" placeholder="选择餐厅">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-button class="btn1">查询</el-button>
          </div>
          <div>
            <div>
              <el-button class="btn2" @click="tableAddFn()">添加桌位</el-button>
            </div>
            <div>
              <el-button class="btn3">排序</el-button>
            </div>
            <div>
              <el-button class="btn4">删除</el-button>
            </div>
          </div>
        </div>
        <div class="tableOne">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            :header-cell-style="tableHeaderColor"
            :cell-style="cellStyle"
            key="five"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column label="排序" sortable width="120">
              <template>
                <el-input></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="餐桌编号" width="450"></el-table-column>
            <el-table-column prop="name" label="桌位二维码" width="450">
              <template slot-scope="scope">
                <img src="@/images/scenic/ewm.png" alt />
                <el-button style="margin-left:10px" type="text" @click="codeSeeFn(scope.row)">查看二维码</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="address" label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="tableAddFn(scope.row)">编辑</el-button>
                <el-button type="text" style="color: #E74C3C;">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页开始 -->
        <div class="pagination">
          <span class="demonstration">共几条记录，</span>
          <span class="demonstration">当前显示第几页</span>
          <el-pagination background layout="prev, pager, next" :total="1000"></el-pagination>
        </div>
        <!-- 分页结束 -->
      </el-card>
    </div>
    <!-- 桌位管理结束 -->
    <!-- 密钥配置开始 -->
    <div v-if="activeIndex==5">
      <!-- <el-card style="height:740px background:#E5E5E5"> -->
      <div class="cardBox">
        <div class="passForm">
          <el-form ref="form" :model="form" label-width="140px">
            <el-form-item label="小程序Appid">
              <span class="xingA">*</span>
              <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="小程序secrect">
              <span class="xingB">*</span>
              <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item class="itemBtn">
              <el-button>重置</el-button>
              <el-button class="btnL">确认保存</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!-- </el-card> -->
    </div>
    <!-- 密钥配置结束 -->
    <!-- 订单列表开始 -->
    <div v-if="activeIndex==6">
      <el-card>
        <div class="orderBox">
          <div>
            <el-input placeholder="订单号"></el-input>
            <el-date-picker v-model="value1" type="date" placeholder="选择日期"></el-date-picker>
            <el-select v-model="value" placeholder="全部餐厅">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-button class="btn1">查询</el-button>
            <el-button class="btn5">导出报表</el-button>
          </div>
        </div>
        <div class="tableOne">
          <el-table
            :data="tableData1"
            :header-cell-style="tableHeaderColor"
            :cell-style="cellStyle"
            :summary-method="getSummaries"
            show-summary
            style="width: 100%; margin-top: 20px"
          >
            <el-table-column prop="id" label="餐饮订单号" width="180"></el-table-column>
            <el-table-column prop="name" label="餐厅名称"></el-table-column>
            <el-table-column prop="amount1" label="菜品名称"></el-table-column>
            <el-table-column prop="amount2" label="订单金额"></el-table-column>
            <el-table-column prop="amount3" label="下单时间"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="orderInfoFn(scope.row)">订单详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页开始 -->
        <div class="pagination">
          <span class="demonstration">共几条记录，</span>
          <span class="demonstration">当前显示第几页</span>
          <el-pagination background layout="prev, pager, next" :total="1000"></el-pagination>
        </div>
        <!-- 分页结束 -->
      </el-card>
    </div>
    <!-- 订单列表结束 -->

    <!-- 餐厅管理档口授权开始 -->
    <restaurantDialog v-if="gateAuthorvisible" ref="gateAuthorDialog"></restaurantDialog>
    <!-- 餐厅管理档口授权结束 -->
    <!-- 餐厅管理添加餐厅开始 -->
    <restaurantDialog v-if="restaurantVisible" ref="restaurantDialog"></restaurantDialog>
    <!-- 餐厅管理添加餐厅结束 -->
    <!-- 档口管理菜品授权开始 -->
    <foodAuthorDialog v-if="foodvisible" ref="foodDialog"></foodAuthorDialog>
    <!-- 档口管理菜品授权结束 -->
    <!-- 添加档口开始 -->
    <foodAuthorDialog v-if="foodAddvisible" ref="foodAddDialog"></foodAuthorDialog>
    <!-- 添加档口结束 -->
    <!-- 添加类别开始 -->
    <foodAuthorDialog v-if="classAddvisible" ref="classAddDialog"></foodAuthorDialog>
    <!-- 添加类别结束 -->
    <!-- 添加菜品开始 -->
    <vegetableDialog v-if="vegetablevisible" ref="vegetableDialog"></vegetableDialog>
    <!-- 添加菜品结束 -->
    <!-- 添加桌位开始 -->
    <vegetableDialog v-if="tablevisible" ref="tableDialog"></vegetableDialog>
    <!-- 添加桌位结束 -->
    <!-- 查看二维码开始 -->
    <vegetableDialog v-if="codevisible" ref="codeDialog"></vegetableDialog>
    <!-- 查看二维码结束 -->
    <!-- 订单详情开始 -->
    <vegetableDialog v-if="orderInfovisible" ref="orderInfoDialog"></vegetableDialog>
    <!-- 订单详情结束 -->
  </div>
</template>

<script>
import restaurantDialog from "./dialog/restaurantDialog.vue";
import foodAuthorDialog from "./dialog/foodAuthorDialog.vue";
import vegetableDialog from "./dialog/vegetableDialog.vue";
export default {
  components: {
    restaurantDialog,
    foodAuthorDialog,
    vegetableDialog
  },
  data() {
    return {
      gateAuthorvisible: false, // 餐厅管理档口授权
      restaurantVisible: false, // 餐厅管理添加餐厅
      foodvisible: false, // 档口管理菜品授权
      foodAddvisible: false, // 添加档口
      classAddvisible: false, // 添加类别
      vegetablevisible: false, // 添加菜品
      tablevisible: false, // 添加桌位
      codevisible: false, // 查看二维码
      orderInfovisible: false, // 订单详情
      radio: "",
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "57674"
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          address: "2464634"
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          address: "43434"
        },
        {
          date: "2016-05-03",
          name: "王小虎",
          address: "1345"
        }
      ],
      tabBtn: [
        {
          id: 1,
          name: "餐厅管理"
        },
        {
          id: 2,
          name: "档口管理"
        },
        {
          id: 3,
          name: "分类管理"
        },
        {
          id: 4,
          name: "菜品管理"
        },
        {
          id: 5,
          name: "桌位管理"
        },
        {
          id: 6,
          name: "密钥配置"
        },
        {
          id: 7,
          name: "订单列表"
        },
        {
          id: 8,
          name: "订单大屏"
        }
      ],
      upOption: [
        {
          id: 1,
          value: "是"
        },
        {
          id: 2,
          value: "否"
        }
      ],
      value: "",
      activeIndex: "", // 选中tab
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      value1: "",
      options: [
        {
          value: "选项1",
          label: "黄金糕"
        },
        {
          value: "选项2",
          label: "双皮奶"
        },
        {
          value: "选项3",
          label: "蚵仔煎"
        },
        {
          value: "选项4",
          label: "龙须面"
        },
        {
          value: "选项5",
          label: "北京烤鸭"
        }
      ],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            }
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            }
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            }
          }
        ]
      },
      value1: "",
      value: "",
      value3: true,
      multipleSelection: [],
      form: {
        name: ""
      },
      tableData1: [
        {
          id: "12987122",
          name: "王小虎",
          amount1: "234",
          amount2: "3.2",
          amount3: 10
        },
        {
          id: "12987123",
          name: "王小虎",
          amount1: "165",
          amount2: "4.43",
          amount3: 12
        },
        {
          id: "12987124",
          name: "王小虎",
          amount1: "324",
          amount2: "1.9",
          amount3: 9
        },
        {
          id: "12987125",
          name: "王小虎",
          amount1: "621",
          amount2: "2.2",
          amount3: 17
        },
        {
          id: "12987126",
          name: "王小虎",
          amount1: "539",
          amount2: "4.1",
          amount3: 15
        }
      ]
    };
  },
  methods: {
    // 订单详情
    orderInfoFn(row) {
      this.orderInfovisible = true;
      this.$nextTick(() => {
        this.$refs.orderInfoDialog.orderInfo(row);
      });
    },

    // 订单列表
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (index === 3) {
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = sums[index].toFixed(2);
          } else {
            sums[index] = "";
          }
        }
      });

      return sums;
    },
    // 查看二维码
    codeSeeFn(row) {
      this.codevisible = true;
      this.$nextTick(() => {
        this.$refs.codeDialog.codeSee(row);
      });
    },
    // 添加桌位
    tableAddFn(row) {
      this.tablevisible = true;
      this.$nextTick(() => {
        this.$refs.tableDialog.addTable(row);
      });
    },
    // 添加菜品
    vegetableAddFn(row) {
      this.vegetablevisible = true;
      this.$nextTick(() => {
        this.$refs.vegetableDialog.vegetable(row);
      });
    },
    // 添加类别
    classAddFn(row) {
      this.classAddvisible = true;
      this.$nextTick(() => {
        this.$refs.classAddDialog.classAdd(row);
      });
    },
    // 添加档口
    foodAddFn(row) {
      this.foodAddvisible = true;
      this.$nextTick(() => {
        this.$refs.foodAddDialog.foodAdd(row);
      });
    },
    // 档口管理菜品授权
    foodAuthorFn(row) {
      this.foodvisible = true;
      this.$nextTick(() => {
        this.$refs.foodDialog.foodAuthor(row);
      });
    },
    // 餐厅管理档口授权
    gateAuthorFn(row) {
      this.gateAuthorvisible = true;
      this.$nextTick(() => {
        this.$refs.gateAuthorDialog.gateAuthor(row);
      });
    },
    // 餐厅管理添加餐厅
    addRestaurantFn(row) {
      this.restaurantVisible = true;
      this.$nextTick(() => {
        this.$refs.restaurantDialog.addRestaurant(row);
      });
    },
    // // 销售统计查看详情
    // seeInfoFn(row) {
    //   this.xstjinfovisible = true;
    //   this.$nextTick(() => {
    //     this.$refs.xstjinfoDialog.seeInfo(row);
    //   });
    // },
    tabTitle(index) {
      // console.log(index);
      this.activeIndex = index;
      console.log(this.activeIndex);
    },
    // 商品管理全选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },

    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    },
    // 文字左对齐表头设置
    tableHeaderColorLeft({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColorLeft({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyleLeft({ row, rowIndex }) {
      return this.utils.cellStyleLeft({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang='less' scoped>
.orderBox {
  margin-bottom: 20px;
  .el-input,
  .el-select {
    width: 220px;
  }
  .el-date-editor {
    width: 280px;
    margin: 0 20px;
  }
}
.cardBox {
  width: 100%;
  height: 600px;
  // background: red;
  display: flex;
  justify-content: center;
  align-items: center;
  .passForm {
    width: 566px;
    height: 254px;
    background: #ffffff;
    .el-form-item {
      position: relative;
    }
    .xingA {
      position: absolute;
      top: 0px;
      left: -100px;
      color: #e74c3c;
    }
    .xingB {
      position: absolute;
      top: 0px;
      left: -106px;
      color: #e74c3c;
    }
    .el-form {
      margin: 40px 0;
      .el-input {
        width: 370px;
      }
    }
    /deep/.el-form-item__label {
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
    }
    /deep/.el-input__inner {
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
    }
    .itemBtn {
      display: flex;
      justify-content: center;
      margin-top: 40px;
      margin-bottom: 20px;
      margin-left: -140px;
      /deep/.el-button {
        width: 100px;
        height: 40px;
        background: #d9d9d9;
        border-radius: 4px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        text-align: center;
        color: #ffffff;
        border: none;
        margin-right: 10px;
      }
      .btnL {
        width: 100px;
        height: 40px;
        background: #246deb;
        border-radius: 4px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        text-align: center;
        color: #ffffff;
      }
    }
  }
}
.vegetableBox {
  display: flex;
  margin-bottom: 20px;
  .el-select {
    width: 220px;
  }
  > div:nth-child(1) {
    width: 60%;
    display: flex;
  }
  > div:nth-child(2) {
    width: 40%;
    display: flex;
    justify-content: flex-end;
  }
}
.btn1 {
  width: 100px;
  background: #246deb;
  border-radius: 4px;
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  border: none;
  margin-left: 20px;
}
.btn5 {
  width: 120px;
  background: #246deb;
  border-radius: 4px;
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  border: none;
  margin-left: 20px;
}
.btn2 {
  width: 110px;
  background: #ffffff;
  border: 1px solid #246deb;
  border-radius: 4px;
  font-family: "OPPOSans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #246deb;
  margin-right: 20px;
}
.btn3 {
  width: 100px;
  background: #ffffff;
  border: 1px solid #246deb;
  border-radius: 4px;
  font-family: "OPPOSans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #246deb;
  margin-right: 20px;
}
.btn4 {
  width: 100px;
  background: #ffffff;
  border: 1px solid #e74c3c;
  border-radius: 4px;
  font-family: "OPPOSans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #e74c3c;
}
.tableOne {
  /deep/.el-table__footer-wrapper tbody td.el-table__cell,
  .el-table__header-wrapper tbody td.el-table__cell {
    background-color: #f5f7fa;
    color: #606266;
    text-align: center;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
  .el-input {
    width: 60px;
    height: 30px;
  }
  /deep/.el-input__inner {
    width: 60px;
    height: 30px;
    background: #f7f7fa;
    border-radius: 4px;
    border: none;
    text-align: center;
  }
}
.typeSet {
  .titleTop {
    margin-bottom: 15px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
  }
  .btn {
    width: 100%;
    text-align: center;
    margin-top: 150px;
    .el-button {
      width: 100px;
      background: #d9d9d9;
      border-radius: 4px;
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
      border: none;
      margin-right: 20px;
    }
    .btnL {
      width: 100px;
      background: #246deb;
      border-radius: 4px;
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
      border: none;
    }
  }
  .styleSet {
    display: flex;
    img {
      width: 300px;
      height: 432px;
      margin-right: 20px;
    }
    .el-radio {
      width: 300px;
      text-align: center;
      margin-top: 20px;
    }
  }
}
.titleSear {
  margin-bottom: 20px;
  display: flex;
  > div:nth-child(1) {
    width: 60%;
    .el-button {
      width: 110px;
      background: #ffffff;
      border: 1px solid #246deb;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #246deb;
    }
  }
  > div:nth-child(2) {
    width: 40%;
    display: flex;
    justify-content: flex-end;

    > div:nth-child(1) {
      .el-button {
        width: 100px;
        background: #ffffff;
        border: 1px solid #246deb;
        border-radius: 4px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: #246deb;
        margin-left: 20px;
      }
    }
    > div:nth-child(2) {
      .el-button {
        width: 100px;
        background: #ffffff;
        border: 1px solid #e74c3c;
        border-radius: 4px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: #e74c3c;
        margin-left: 20px;
      }
    }
  }
}
.conentRow {
  display: flex;
  margin-bottom: 20px;
  .el-date-editor {
    margin-right: 20px;
  }
  .el-input {
    width: 220px;
    margin-right: 20px;
  }
  .el-select {
    width: 220px;
    margin-right: 20px;
  }
  .conentBtn {
    width: 100px;
    background: #246deb;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    border: none;
    color: #ffffff;
    border: none;
    margin-right: 10px;
  }
  .conentBtn1 {
    width: 120px;
    background: #246deb;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    border: none;
    color: #ffffff;
    border: none;
    margin-right: 10px;
  }
}

.qxsq {
  // 分页
  .pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 32px;
    margin: 30px auto 20px;
    span {
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
    }
  }
}

.tab {
  display: flex;
  margin: 20px 0;
  .activeTab {
    background: #246deb;
  }
  span {
    width: 120px;
    height: 40px;
    display: block;
    border-radius: 0px 0px 4px 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 40px;
    color: #ffffff;
    border: none;
    text-align: center;
    background: #d9d9d9;
    margin-right: 20px;
  }
}
// /deep/.el-dialog__header {
//   height: 60px;
//   line-height: 60px;
//   padding: 0;
// }

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}
// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 45px auto 40px;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}
</style>